import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { finalize } from "rxjs/operators";
import { PageLoadingService } from "src/app/shared/services/page-loading/page-loading.service";

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  private loading: boolean = false;

  constructor(private loaderService: PageLoadingService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    this.handleRequest(true);
    return next.handle(req).pipe(finalize(() => this.handleRequest(false)));
  }

  private handleRequest(isLoading: boolean) {
    this.loading = isLoading;
    if (isLoading) {
      this.loaderService.show(); // Show loader
    } else {
      this.loaderService.hide(); // Hide loader
    }
  }
}
